import React, { useState } from 'react';
import {
    CardBody,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from 'reactstrap';
import { TARGET_FIREBASE, YES_CONTINUE } from "../i18n/i18n";
import {fbDatabaseProvider} from "../../providers/fbDatabaseProvider";
import SelectGeneric from "../select/selectGeneric";

export default function FirebaseTarget(props) {
    const [noDb, setNoDb] = useState(false);
    const [allDb, setAllDb] = useState(false);
    const [existingDb, setExistingDb] = useState(false);
    const [toSpecific, setToSpecific] = useState(false);
    const [db, setDb] = useState(null);

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onAnyChange = (none, all, existing, specific) => {
        setNoDb(none);
        setAllDb(all);
        setExistingDb(existing);
        setToSpecific(specific);
    }

    return (
        <CardBody className="">
            {/*{ loading ? showLoader() : null }*/}
            <div className='custom-ui'>
                <h1>{TARGET_FIREBASE}</h1>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <Input
                                addon type="checkbox"
                                checked={noDb}
                                onChange={_=> onAnyChange(true, false, false, false)}
                            />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input defaultValue={"No enviar (solo relacional)"} />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <Input addon type="checkbox"
                                   checked={allDb}
                                   onChange={_=> onAnyChange(false, true, false, false)}
                            />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input defaultValue={"Enviar a todas las bases configuradas"} />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <Input addon type="checkbox"
                                   checked={existingDb}
                                   onChange={_=> onAnyChange(false, false, true, false)}
                            />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input defaultValue={"Enviar a todas donde exista"} />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <Input addon type="checkbox"
                                   checked={toSpecific}
                                   onChange={_ => onAnyChange(false, false, false, true)}
                            />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input defaultValue={"Enviar a:"} />
                </InputGroup>
                <FormGroup>
                    <FormGroup>
                        <SelectGeneric
                            initialValue={db}
                            setExternalValue={setDb}
                            provider={ fbDatabaseProvider }
                            customFilter={ { item: { code: props.className } } }
                            isDisabled={ !toSpecific }
                        />
                    </FormGroup>
                </FormGroup>
                <button className="btn-alert-delete"
                        onClick={() => {
                            props.onSubmit(
                                props.data ,  {
                                    noDb : noDb,
                                    allDb : allDb,
                                    existingDb: existingDb,
                                    fbDataBase :  { id : db },
                            })
                            props.onClose()
                        }}
                >
                    { YES_CONTINUE }
                </button>
            </div>
        </CardBody>
    )
}